// Add below for anchor
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import { Col, Row, Dropdown, MenuItem } from '@bingads-webui-react/primitive';
import { DoubleListBoxView, doubleListBoxStyles as getDoubleListBoxStyles } from '@bingads-webui-react/double-list-box';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { CombinedListStyle } from './styles/combined-list-styles';
import { AudienceSetOperator, AudienceType } from './constants';

const DoubleListBoxViewThemed = withDefaultStyles(DoubleListBoxView, getDoubleListBoxStyles);

export class AudienceSetDetail extends React.PureComponent {
  state = {
    operator: this.props.audienceSet.operator,
    audiences: this.props.audienceSet.audiences,
    error: null,
  };

  onOperatorChange = (newOperator) => {
    this.setState({ operator: newOperator });
  };

  onDoubleListBoxChange = (isAdding, categoryIndex, audienceName) => {
    const newSelectedAudiences = this.performActionToAudienceSelection(
      isAdding,
      categoryIndex,
      audienceName,
      this.state.audiences
    );
    this.setState({ audiences: newSelectedAudiences, error: null });
  };

  onSaveAudienceSet = () => {
    const error = this.props.onSave(this.state.operator, this.state.audiences);

    if (error) {
      this.setState({ error });
    }
  };

  performActionToAudienceSelection = (isAdding, categoryIndex, audienceNames, prevSelection) => {
    // With new double list box the category index is meaningless
    if (isAdding) {
      const audiencesToChange = _.compact(_.map(
        audienceNames,
        name => this.props.audienceDao.getAudienceByName(name)
      ));
      return _.uniq([...prevSelection, ...audiencesToChange]);
    }

    return _.filter(prevSelection, prevSelectedAudience =>
      !_.contains(audienceNames, prevSelectedAudience.Name));
  };

  mergeDataToDoubleListBoxFormat = (operator, selectedAudiences) => {
    const selectedAudiencesByTypeValue =
      _.groupBy(selectedAudiences, audience => audience.Type.value);
    const disabledAudienceTypes = this.props.getDisabledAudienceTypes(operator, selectedAudiences);

    const unavailable = {
      name: this.props.i18n.getString('Unavailable_Audience_List'),
      description: '',
      disabled: false,
      notShowInSource: true,
      data: {
        items: [],
        selected: _.map(selectedAudiencesByTypeValue.NotAvailable, x => x.Name),
        disabled: [],
        showUnavailableItem: true,
      },
    };

    const dataForDoubleListBox = _.map(
      _.values(AudienceType),
      (audienceType) => {
        const allAudiencesOfThisType =
          this.props.audienceDao.getAudiencesByType(audienceType) || [];
        const selectedAudiencesOfThisType = selectedAudiencesByTypeValue[audienceType.value] || [];
        const disabledAudiencesOfThisType = this.props.getDisabledAudiences(operator, audienceType);
        const isDisabled = _.some(disabledAudienceTypes, x => x === audienceType);

        return {
          name: this.props.i18n.getString(audienceType.i18nKey),
          description: this.props.i18n.getString(audienceType.descI18nKey),
          disabled: isDisabled,
          data: {
            items: _.map(allAudiencesOfThisType, x => x.Name),
            selected: _.map(selectedAudiencesOfThisType, x => x.Name),
            disabled: _.map(disabledAudiencesOfThisType, x => x.Name),
          },
        };
      }
    );

    return selectedAudiencesByTypeValue.NotAvailable ?
      _.union([unavailable], dataForDoubleListBox) : dataForDoubleListBox;
  };

  discardChange = () => {
    this.setState({
      operator: this.props.audienceSet.operator,
      audiences: this.props.audienceSet.audiences,
      error: null,
    });
  };

  renderAudienceSetEditor = (doubleListBoxData, editingError) => {
    const errorMessage = editingError && editingError.message;

    return (
      <React.Fragment>
        <div style={CombinedListStyle.audienceSetEditPanel} className="audience-set-edit-panel">
          <div style={CombinedListStyle.audienceSetEditPanelOperatorSelector} className="operator-selector">
            <Dropdown id="audience-set-relationship-selection">
              <Dropdown.Toggle id="dropdown-basic">
                {this.props.i18n.getString(this.state.operator.i18nKey)}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {
                  _.map(
                    AudienceSetOperator,
                    operator => (
                      <MenuItem
                        onClick={() => { this.onOperatorChange(operator); }}
                        key={operator.value}
                      >
                        {this.props.i18n.getString(operator.i18nKey)}
                      </MenuItem>
                    )
                  )
                }
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <DoubleListBoxViewThemed
            i18n={this.props.i18n}
            data={doubleListBoxData}
            onChange={this.onDoubleListBoxChange}
          />
          <Row style={CombinedListStyle.audienceSetEditPanelError} className="audience-set-error">
            {errorMessage}
          </Row>
          <div style={CombinedListStyle.audienceSetEditPanelButtons} className="audience-set-edit-panel-buttons">
            <input
              type="button"
              className="btn btn-primary"
              onClick={() => this.onSaveAudienceSet(this.state.operator, this.state.audiences)}
              value={this.props.i18n.getString('Custom_Combination_Save_Audience_Set_Button_Text')}
            />
            <input
              type="button"
              className="btn btn-default"
              onClick={() => { this.discardChange(); this.props.onCancel(); }}
              value={this.props.i18n.getString('Custom_Combination_Cancel_Audience_Set_Button_Text')}
            />
          </div>
        </div>
      </React.Fragment>
    );
  };

  renderAudienceSetDisplayer = (selectedAudiences, displayError) => (
    <React.Fragment>
      <div style={CombinedListStyle.audienceSetPanel} className="audience-set-panel">
        <div style={CombinedListStyle.audienceSetPanelHeader} className="audience-set-panel-header">
          <div style={CombinedListStyle.audienceSetPanelHeaderTitle} className="audience-set-panel-header-title">
            {this.props.i18n.getString(this.state.operator.i18nKey)}
          </div>
          <div style={CombinedListStyle.audienceSetPanelHeaderLinks} className="audience-set-panel-header-links">
            <a className="clickable" onClick={() => this.props.onEdit()} role="button" tabIndex="0">
              {this.props.i18n.getString('Custom_Combination_Edit_Audience_Set_Button_Text')}
            </a>
            <span>|</span>
            <a className="clickable" onClick={() => this.props.onRemove()} role="button" tabIndex="0">
              {this.props.i18n.getString('Custom_Combination_Remove_Audience_Set_Button_Text')}
            </a>
          </div>
        </div>
        <hr style={CombinedListStyle.audienceSetEditPanelSeparationLine} />
        <div className="audience-set-panel-list-container">
          {
            // Audience name and audience type
            _.map(selectedAudiences, audience => (
              <ol key={audience.Id.toString()}>
                <li style={CombinedListStyle.audienceSetListItem}>
                  <Col sm={8}>
                    {
                      audience.NotAvailable ?
                        <span style={CombinedListStyle.audienceSetError}>
                          {audience.Name}
                        </span>
                        :
                        audience.Name
                    }
                  </Col>
                  <Col sm={4}>
                    {audience.NotAvailable ? '' : this.props.i18n.getString(audience.Type.i18nKey)}
                  </Col>
                </li>
              </ol>
            ))
          }
        </div>
        <Row style={CombinedListStyle.audienceSetError}>
          {displayError && displayError.message}
        </Row>
      </div>
    </React.Fragment>
  );


  render() {
    // Only show the selected audiences list
    if (this.props.audienceSet.isEditing) {
      const doubleListBoxData =
        this.mergeDataToDoubleListBoxFormat(this.state.operator, this.state.audiences);
      const editingError = this.state.error ||
        this.props.validateAudienceSet(this.state.operator, this.state.audiences);

      return this.renderAudienceSetEditor(doubleListBoxData, editingError);
    }

    const displayError = this.state.error;
    return this.renderAudienceSetDisplayer(this.props.audienceSet.audiences, displayError);
  }
}


AudienceSetDetail.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,

  audienceDao: PropTypes.shape({
    getAudienceByName: PropTypes.func.isRequired,
    getAudienceById: PropTypes.func.isRequired,
    getAudiencesByType: PropTypes.func.isRequired,
    getAllAudiences: PropTypes.func.isRequired,
  }).isRequired,

  audienceSet: PropTypes.shape({
    operator: PropTypes.any.isRequired,
    audiences: PropTypes.array.isRequired,
    isEditing: PropTypes.bool.isRequired,
  }).isRequired,

  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,

  validateAudienceSet: PropTypes.func.isRequired,
  getDisabledAudienceTypes: PropTypes.func.isRequired,
  getDisabledAudiences: PropTypes.func.isRequired,
};
